<template>
  <div class="position-ab">
    <template v-if="show">
      <!-- 未汇总 -->
      <template v-if="summaryStaus == 0">
        <noSummary :type="0"></noSummary>
      </template>
      <!-- 汇总中 -->
      <template v-else-if="summaryStaus == 1">
        <summaryingOrComplete :status="0" :type="0"></summaryingOrComplete>
      </template>
      <!-- 汇总完成 -->
      <template v-else-if="summaryStaus == 2">
        <summaryingOrComplete :status="1" :type="0"></summaryingOrComplete>
      </template>
    </template>
  </div>
</template>

<script>
import noSummary from "@/app/subSourcingFlow/views/expertEvaluate/components/noSummary.vue";
import summaryingOrComplete from "@/app/subSourcingFlow/views/expertEvaluate/components/summaryingOrComplete.vue";
import { scpQryBidEvaProcessStatusApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "technicalScoreSummary",
  components: {
    noSummary,
    summaryingOrComplete
  },
  data() {
    return {
      show: false,
      summaryStaus: Number(
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus
      ) // 0:未汇总 1：汇总中 2：汇总完成
    };
  },
  mounted() {
    scpQryBidEvaProcessStatusApi({
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId,
      purStep: this.$router.history.current.query.menuKey,
      evaPurStep: this.$router.history.current.query.evaPurStep
    }).then(res => {
      this.$set(this, "summaryStaus", res.data.data.billStatus);
      this.show = true;
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
